import { render, staticRenderFns } from "./SetDetailsTab.vue?vue&type=template&id=4c381def&scoped=true&"
import script from "./SetDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SetDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c381def",
  null
  
)

export default component.exports